<template>
  <div role="toolbar" class="p-1 mt-2 btn-toolbar" style="background-color:#eee;">
    <div class="btn-group">
      <button :id="'export' + index" @click="exportData" class="btn btn-sm btn-secondary"><font-awesome-icon icon="save"/></button>
      <!-- <b-tooltip :target="'export' + index">Datenquelle exportieren</b-tooltip> -->
      <button :id="'refresh' + index" @click="updateReport" class="btn btn-sm btn-secondary"><font-awesome-icon icon="redo"/></button>
      <!-- <b-tooltip :target="'refresh' + index">Bericht mit den aktuellen Parametern neu laden</b-tooltip> -->
    </div>
    <div class="form-inline ml-2" v-for="(val,key) in widget.params" :key="key">
      <label>{{ key }}</label>
      <input type="text" class="ml-2 form-control form-control-sm" v-model="val.value" v-if="val.type == 'text'"/>
    </div>
    <div class="form-inline">
      <button v-if="loads" class="ml-3 btn btn-sm btn-info"><font-awesome-icon spin icon="spinner"/></button>
    </div>
    <b-modal :id="'exportselect' + index" title="Exportieren" @ok="doExport">
      <div class="form-group">
        <label>Tabelle auswählen:</label>
        <select v-model="exportName" class="form-control">
          <option v-for="(val,key) in report.datasource" :key="key" :value="key">{{ key }}</option>
        </select>
      </div>
      <ExportConfigWidget :config="exportCfg"/>
      <div class="form-check">
        <input v-model="edownload" type="checkbox" class="form-check-input" :id="'expdown' + index">
        <label :for="'expdown' + index">direkter Download</label>
      </div>
    </b-modal>
    <b-modal :id="'down' + index">
      <a :id="'downref' + index" :download="downname" :href="downurl">Download</a>
    </b-modal>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import reports from '@/modules/reports.js'
import datamap from '@/modules/datamap.js'
import ExportConfigWidget from '@/components/genericdata/ExportConfigWidget.vue'

export default {
  name: 'DashToolbar',
  props: ["widget","index","userid"],
  components: {
    ExportConfigWidget
  },
  data() {
    return {
      loads: false,
      reloads: 0,
      baseurl: "/",
      report: false,
      exportCfg: {},
      exportName: '',
      edownload: false,
      downurl: '',
      downname: 'daten.dat'
    }
  },
  created: function() {
    console.log(config.baseUrl);
  },
  methods: {
    createParams() {
      var params = {};
      for (var key in this.widget.params) {
        params[key] = this.widget.params[key].value;
      }
      return params;
    },
    updateReport: function() {
      var self = this;
      this.loads = true;
      // create params
      var params = this.createParams();
      this.reloads++;
      reports.create(this,{ load: this.widget.report},params,this.userid,function() {
        var iframe = document.getElementById('widget' + self.index);
        setTimeout(function() {
          self.loads = false;
          iframe.src = self.baseurl + 'dashboard/1/' + encodeURIComponent(self.widget.name) + '/index.html?r=' + self.reloads;
        },1500);
      })
    },
    doExport() {
      var robj = this.report.datasource[this.exportName];
      if (!robj) return;

      var cfg     = JSON.parse(JSON.stringify(this.exportCfg));
      var params  = this.createParams();
      var tempcfg = { name: this.exportName, config: { tables: robj }};
      var self    = this;

      // check for referenced or direct configured datasource
      if (typeof robj === 'string') {
        // load ref table config
        datamap.loadtable(robj,this,function(data) {
          // inject parameter
          tempcfg.config.tables = data.config.tables;
          reports.injectparams(this,tempcfg,params,function(data) {
            cfg.tablecfg = data;
            datamap.exporttable(self,'*',cfg,self.edownload,function(data) {
              if (self.edownload) {
                self.downname = data.type;
                self.downurl = window.URL.createObjectURL(data);
                self.$bvModal.show('down' + self.index);
              }
            });
          })
        })
      } else {
        console.log('INJECT PARAMETER')
        reports.injectparams(this,tempcfg,params,function(data) {
          cfg.tablecfg = data;
          datamap.exporttable(self,'*',cfg,self.edownload,function(data) {
            if (self.edownload) {
              self.$bvModal.show('down' + self.index);
              self.downname = data.type;
              self.downurl = window.URL.createObjectURL(data);
              self.$bvModal.show('down' + self.index);
            }
          })
        })
      }

    },
    exportData() {
      if (!this.report) {
        var self = this;
        reports.load(this.widget.report,function(data) {
          self.report = data;
          self.$bvModal.show('exportselect' + self.index);
        });
      } else {
        this.$bvModal.show('exportselect' + this.index);
      }
    }
  }
}
</script>
